/** @jsxImportSource @emotion/react */
import React, { useCallback, useState,useContext } from 'react'
import { Snackbar } from "@mui/material"
// import { withStyles } from '@mui/styles';
import MySnackbarContentWrapper from '../../Components/Snackbars';
import { useDropzone } from 'react-dropzone'
import LivePhotoUpload from './LivePhotoUpload';
import { Il8nContext } from '../../Helper/i18n';


const style = theme => ({
    root: {
        width: "120px",
        height: "120px",
        outline: "none !important",
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }
})
function Upload(props) {
    const { onFile, activate } = props;
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [responseStatus, setResponseStatus] = useState({})
    const [openLivePhotoDialog, setOpenLivePhotoDialog] = useState(false)
    const localeText = useContext(Il8nContext)

    const classes = {
        width: "120px",
        height: "120px",
        outline: "none !important",
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }

    const onDrop = useCallback(acceptedFiles => {
        let reader = new FileReader();
        let promise = new Promise((res, rej) => {
            reader.onload = (readBytes) => {
                let file = {};
                try {
                    file.data = readBytes.currentTarget.result
                    file.type = acceptedFiles[0].type
                    file.size = acceptedFiles[0].size
                    file.name = acceptedFiles[0].name
                    res(file);
                    // props.setId();
                }
                catch (ex) {
                    file.error = ex
                    rej(file)
                }
            }
        })
        // reader.readAsDataURL(acceptedFiles[0]) 
        // onFile(promise,props.docId,props.count,props.docName);
        if (checkForValidDocumentType(acceptedFiles[0].name.toLowerCase())) {
            if (!((acceptedFiles[0].name.toLowerCase()).includes("pdf")) && acceptedFiles[0].size / (1024 * 1024) > 5) {
                setResponseStatus({ "message": localeText?.uploadValidProof, "type": "error" })
                setSnackBarOpen(true)
            } else {
                reader.readAsDataURL(acceptedFiles[0])
                onFile(promise, props.docId, props.count, props.docName, props.mappingKey, props.setId());
            }
        }
        else {
            setResponseStatus({ "message": localeText?.uploadValiDocFormat, "type": "error" })
            setSnackBarOpen(true)
        }
    }, [onFile])
    const { getRootProps, getInputProps } = useDropzone({ onDrop })

    var checkForValidDocumentType = (docName) => {
        var isValidDocumentType = false;
        if (props.accept) {
            // var splits = props.accept.split(",")
            // for(let i=0; i<splits.length; i++){                
            //     if(docName.includes( (splits[i].trim()) )){
            //         isValidDocumentType = true;
            //         break;
            //     }
            // }
            if (props.accept.includes("pdf")) {
                if (docName.includes("pdf") || docName.includes("jpg") || docName.includes("png") || docName.includes("jpeg") || docName.includes("svg")) {
                    isValidDocumentType = true
                }
            }
            else if (props.accept.includes("jpg")) {
                if (docName.includes("jpg") || docName.includes("png") || docName.includes("jpeg") || docName.includes("svg")) {
                    isValidDocumentType = true
                }
            }
        }
        else if (docName.includes("jpg") || docName.includes("png") || docName.includes("jpeg") || docName.includes("pdf") || docName.includes("svg")) {
            isValidDocumentType = true
        }
        return isValidDocumentType;
    }

    function handleSnackBarClose(event, reason) {
        setSnackBarOpen(false)
        setResponseStatus()
    }

    const handleLivePhotoDialog = () => {
        setOpenLivePhotoDialog(!openLivePhotoDialog)
    }

    // useEffect(()=> {
    //     if(activate === true) {
    //        getRootProps().onClick({preventDefault: ()=>{}})
    //     }            
    // }, [])
    return <>
        {props.isLivePhotoCapture ?
            <>
                <div tabindex={props.tabIndex} title={props.text}  className={`${classes.root} ${props.boxStyle}`} style={props.boxStyle} onClick={() => { handleLivePhotoDialog() }}>
                    <div tabindex={props.tabIndex}>
                        <img src={props.current ? props.activeImage : props.image} style={{ marginTop: '20px' }} alt="" />
                        <p style={{ ...(props.index === props.active ? { color: '#fff' } : { color: '#999999' }), fontSize: "11px", height: "45px", overflow: "hidden" }}>{ }</p>
                    </div>
                </div>
            </>
            :
            <div tabindex={props.tabIndex} title={props.text}  {...getRootProps()} className={`${classes.root} ${props.boxStyle}`} style={props.boxStyle}>
                <input {...getInputProps()} accept={props.accept || ".png, .jpg, .jpeg, .pdf, .svg"} />
                <div tabindex={props.tabIndex} style={props.center}>
                    <img src={props.current ? props.activeImage : props.image} style={{ marginTop: '20px' }} alt="" />
                    <p style={{ ...(props.index === props.active ? { color: '#fff' } : { color: '#999999' }), fontSize: "11px", height: "45px", overflow: "hidden" }}>{props.text}</p>
                </div>
            </div>
        }

        <LivePhotoUpload handleLivePhotoCapture={props.handleLivePhotoCapture} handleLivePhotoDialog={handleLivePhotoDialog} setSnackBarOpen={setSnackBarOpen} setResponseStatus={setResponseStatus} openLivePhotoDialog={openLivePhotoDialog} docId={props.docId} count={props.count} docName={props.docName} mappingKey={props.mappingKey} />

        {
            responseStatus && responseStatus.message &&
            <Snackbar
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                open={snackBarOpen}
                autoHideDuration={5000}
                onClose={handleSnackBarClose}
            >
                <MySnackbarContentWrapper
                    onClose={handleSnackBarClose}
                    variant={responseStatus.type}
                    message={responseStatus.message}
                />
            </Snackbar>
        }
    </>
}
export default /* withStyles(style) */(Upload)